import { CONSTANTS } from '@shared/constants';

export const ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS = {
  BASE_PATH: CONSTANTS.ROUTES.VENUES,
  CREATE: CONSTANTS.ROUTES.CREATE,
  EDIT: `${CONSTANTS.ROUTES.EDIT}/:${CONSTANTS.ROUTE_PARAMS.VENUE_ID}`,
};
export const ACCOUNT_VENUES_ROUTES_PATHS_FULL = {
  CREATE: `${ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS.CREATE}`,
  EDIT: `${ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS.EDIT}`,
  LIST: `${ACCOUNT_VENUES_ROUTES_PATHS_PARTIALS.BASE_PATH}`,
};
